import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getDropdownMenuTheme = function getDropdownMenuTheme(theme) {
  return ThemeFactory.create({
    popupMargin: theme.dropdownMenuMenuOffsetY,
    menuBoxSizing: theme.dropdownMenuMenuBoxSizing,
    menuPaddingY: theme.menuScrollContainerContentWrapperPaddingY,
    menuScrollContainerContentWrapperPaddingY: theme.menuPaddingY,
    scrollContainerScrollBarOffsetY: theme.dropdownMenuScrollContainerScrollBarOffsetY
  }, theme);
};